import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, HeartIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 px-4 bg-cream" data-id="element-106">
      <div className="max-w-4xl mx-auto" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-109">
            Pero el problema no es tu cultura...
          </h2>
          <p className="text-xl md:text-2xl text-espresso/80" data-id="element-110">
            Es que los ingredientes que compramos hoy en el supermercado están
            llenos de químicos e inflamatorios que tu cuerpo ya no reconoce.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-111">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 rounded-3xl shadow-warm border-t-4 border-terracotta" data-id="element-112">
            <FlameIcon className="w-12 h-12 text-terracotta mb-4" data-id="element-113" />
            <h3 className="text-2xl font-bold mb-4" data-id="element-114">El Incendio Interno</h3>
            <p className="text-lg" data-id="element-115">
              Estás "incendiada" por dentro y tu comida de siempre, hecha con
              ingredientes procesados de hoy, es la gasolina de ese incendio.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-white p-8 rounded-3xl shadow-warm border-t-4 border-sage" data-id="element-116">
            <HeartIcon className="w-12 h-12 text-sage mb-4" data-id="element-117" />
            <h3 className="text-2xl font-bold mb-4" data-id="element-118">La Solución</h3>
            <p className="text-lg" data-id="element-119">
              He creado un sistema para que vuelvas a comer tus arepas, tus
              tortillas y tu cafecito, pero cambiando la base por ingredientes
              que sanan. Se llama el{' '}
              <strong data-id="element-120">Método de Sustitución Ancestral</strong>: el sabor de tu
              abuela con la ciencia de hoy.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}